/**
 * Safely decode the payload of a JWT token without throwing.
 *
 * @returns The parsed payload object, or `null` if the token is malformed.
 */
export function decodeJWTPayload(token: string): Record<string, unknown> | null {
  try {
    const parts = token.split('.')
    if (parts.length !== 3) return null
    return JSON.parse(atob(parts[1])) as Record<string, unknown>
  } catch {
    return null
  }
}

/**
 * Check whether a JWT token is expired based on its `exp` claim.
 *
 * Returns `true` if the token is corrupted, missing an `exp` claim, or past expiry.
 */
export function isJWTExpired(token: string): boolean {
  const payload = decodeJWTPayload(token)
  if (!payload || typeof payload.exp !== 'number') return true
  return payload.exp * 1000 < Date.now()
}
